import { Activity } from "lucide-react";

const AGENT_COLORS = {
  Scout: "#34C759",
  Architect: "#8A2BE2",
  Creator: "#007AFF",
  Designer: "#FFCC00",
  Validator: "#FF9500",
  Marketer: "#00C7BE",
  Analyst: "#FF2D55",
  Builder: "#5856D6",
};

const STATUS_CHAR = {
  success: "\u2713",
  warning: "\u26A0",
  error: "\u2717",
};

function timeAgo(isoString) {
  const diff = Date.now() - new Date(isoString).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  return `${Math.floor(hrs / 24)}d`;
}

export function AgentFeed({ logs }) {
  if (!logs || logs.length === 0) return null;

  return (
    <div data-testid="agent-feed" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <div className="panel-header">
        <span className="panel-title">
          <Activity size={10} strokeWidth={1.5} style={{ display: "inline", marginRight: 6 }} />
          ACTIVIDAD DE AGENTES
        </span>
        <span className="font-mono" style={{ fontSize: 9, color: "#71717a" }}>
          LIVE FEED
        </span>
      </div>

      <div className="panel-body">
        {logs.map((log, i) => {
          const color = AGENT_COLORS[log.agent_name] || "#a1a1aa";
          const statusChar = STATUS_CHAR[log.status] || "";
          const statusColor = log.status === "success" ? "#34C759" : log.status === "warning" ? "#FFCC00" : "#FF3B30";

          return (
            <div key={log.id || i} className="feed-item" data-testid={`agent-log-${i}`}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                <span className="font-mono" style={{ fontSize: 9, color: "#52525b", flexShrink: 0, width: 28, textAlign: "right" }}>
                  {timeAgo(log.timestamp)}
                </span>
                <span style={{ color: statusColor, fontSize: 10, flexShrink: 0, width: 12, textAlign: "center" }}>
                  {statusChar}
                </span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                    <span className="font-mono" style={{
                      fontSize: 9, color, fontWeight: 500, letterSpacing: "0.05em"
                    }}>
                      {log.agent_name.toUpperCase()}
                    </span>
                    <span className="font-mono" style={{ fontSize: 8, color: "#52525b" }}>
                      {log.agent_model}
                    </span>
                    {log.cost_usd > 0 && (
                      <span className="font-mono" style={{ fontSize: 8, color: "#52525b", marginLeft: "auto" }}>
                        ${log.cost_usd.toFixed(4)}
                      </span>
                    )}
                  </div>
                  <div className="font-mono" style={{
                    fontSize: 10, color: "#a1a1aa", lineHeight: 1.4,
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"
                  }}>
                    {log.detail}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
